import { ROUTES } from './routes'

export const NAV_LINKS = [
    { path: ROUTES.MONEY_FLOW, text: 'ДДС', role: 'USER'},
    { path: ROUTES.ORGANIZATION, text: 'ОРГАНИЗАЦИЯ', role: 'USER'},
    { path: ROUTES.PRODUCT, text: 'ТОВАРЫ', role: 'USER'},
]
